export const AppSettings = {
  'IS_FIREBASE_ENABLED': false,
  'SHOW_START_WIZARD': true,
  'SUBSCRIBE': true,
  'FIREBASE_CONFIG': {
    'apiKey': "AIzaSyB4cnA5xgTdpzyyQULIHzRyO2pr1WcUUFM",
    'authDomain': "robby-84901.firebaseapp.com",
    'databaseURL': "https://robby-84901.firebaseio.com",
    'projectId': "robby-84901",
    'storageBucket': "robby-84901.appspot.com",
    'messagingSenderId': "779549101081",
    'appId': "1:779549101081:web:6b7f9b0d4512a134f0ae88",
    'measurementId': "G-V5WTJNM7M7"
  }
};
